import { createFileRoute } from "@tanstack/react-router";
import { safeNext } from "@/app/safe-next";
import { PortalSignInPage } from "@/features/portalsignin/PortalSignInPage";

/** P101 Portal sign in: the magic link and passkey entry, shown before any client data loads. `next` (X13-0811a) is an
 *  optional same-origin path to return to after the sign-in, such as the confirm page of an emailed approval. */
export const Route = createFileRoute("/portal/sign-in")({
  validateSearch: (search: Record<string, unknown>): { next?: string } => {
    const next = safeNext(search.next);
    return next ? { next } : {};
  },
  component: SignInRoute,
});

function SignInRoute() {
  const { next } = Route.useSearch();
  return <PortalSignInPage next={next} />;
}
